export default "__VITE_ASSET__BVkR7OPC__"